// «أسئلة»: dark image band, a sticky heading on one side and the accordion on the
// other. REFERENCE.md §14, spec section 9.
//
// Every answer goes through fillVars, and a question whose answer comes back empty
// (its number is unknown) is dropped rather than guessed. One question is open at a
// time, the first to start with, and clicking the open one closes it.

import { useId, useState } from "react";
import CtaLink from "./CtaLink";
import { Plus } from "lucide-react";
import { fillVars } from "../Home/content";
import SectionHead from "./SectionHead";
import { Photo } from "./media";
import { FAQ_BAND } from "./copy";
import "./FaqBand.css";

export default function FaqBand({ faq, vars, ctaText, ctaHref }) {
    const baseId = useId();
    const [openIndex, setOpenIndex] = useState(0);

    const items = (faq.items || [])
        .map((it) => ({ ...it, a: fillVars(it.a, vars) }))
        .filter((it) => it.q && it.a);

    return (
        <section className="ld-section ld-section--band ld-faq" id="faq" aria-labelledby="ld-faq-title">
            <div className="ld-decor" aria-hidden="true">
                <Photo name="stock" portrait={false} className="ld-photo ld-faq__photo" />
                <div className="ld-faq__veil" />
                <div className="ld-grain" />
            </div>

            <div className="ld-container ld-faq__grid">
                <div className="ld-faq__main">
                    <SectionHead id="ld-faq-title" eyebrow={faq.eyebrow} title={faq.title} lead={FAQ_BAND.lead} flat />
                    <div className="ld-faq__actions" data-ld="rise" style={{ "--ld-d": ".4s" }}>
                        <CtaLink href={ctaHref} className="ld-btn ld-btn--primary">{ctaText}</CtaLink>
                    </div>
                    {faq.moreLink ? (
                        <p className="ld-small ld-faq__more" data-ld="rise" style={{ "--ld-d": ".5s" }}>
                            {faq.more} <a className="ld-link" href="#contact">{faq.moreLink}</a>
                        </p>
                    ) : null}
                </div>

                <ul className="ld-faq__list" data-ld="rise" style={{ "--ld-d": ".2s" }}>
                    {items.map((it, i) => {
                        const open = i === openIndex;
                        const panelId = `${baseId}-${i}`;
                        return (
                            <li key={it.id || it.q} className={`ld-faq__item ${open ? "is-open" : ""}`.trim()}>
                                <h3 className="ld-faq__q">
                                    <button
                                        type="button"
                                        className="ld-faq__btn"
                                        aria-expanded={open}
                                        aria-controls={panelId}
                                        onClick={() => setOpenIndex(open ? -1 : i)}
                                    >
                                        <span>{it.q}</span>
                                        <span className="ld-faq__icon" aria-hidden="true"><Plus /></span>
                                    </button>
                                </h3>
                                <div className="ld-faq__a" id={panelId}>
                                    <div className="ld-faq__a-inner">
                                        <p>{it.a}</p>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
}
